import {User} from "oidc-client-ts";

export const isUserGaiaXStaff = (user: User | null | undefined): boolean => {
    if (!user || !user.profile || !user.profile.realm_access) {
        return false;
    }
    return ((user?.profile?.realm_access as any).roles as string[]).some((role: string) => role === "academy-staff")
}
export const isUserTokenManager = (user: User | null | undefined): boolean => {
    if (!user || !user.profile || !user.profile.realm_access) {
        return false;
    }
    return ((user?.profile?.realm_access as any).roles as string[]).some((role: string) => role === "token-manager")
}